import { render, staticRenderFns } from "./ModalDetalhesResidue.vue?vue&type=template&id=221ae744&scoped=true"
import script from "./ModalDetalhesResidue.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesResidue.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhesResidue.vue?vue&type=style&index=0&id=221ae744&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ae744",
  null
  
)

export default component.exports